import _ from 'lodash';
import { prepareTokenBase } from 'library-@/token-base/index.js';
import { PRESETS_TOKEN_BASE_PATENT_VIEW } from 'library-@/token-base/presets.js';
import { generateExceptionRedirector } from '@patsnap/common-ps-http';
import { injectService } from '@patsnap/tahiti-core';
import { GetPatentViewInit, type ApiGetPatentViewInitResponse } from '@/infrastructure/api-functions/core-search-api/patent-view-init-api';
import { ejectCommonInterceptor } from './eject-common-interceptor';

const REQUEST_DEMO_PATH = '/request_demo?project=search';

export async function prepareToken(urlParams: Record<string, string> = {}) {
    const pageInit = injectService<GetPatentViewInit>(GetPatentViewInit);

    let isFreeView = false;
    let isFirstTimeCheckSession = true;

    try {
        await prepareTokenBase({
            ...PRESETS_TOKEN_BASE_PATENT_VIEW,
            preRedirectLogin() {
                // 只有第一次 CheckSession 时拦截跳转 用于判断 free
                if (isFirstTimeCheckSession) {
                    throw new Error('Anonymous');
                }
            },
        });
    } catch (error) {
        if (error instanceof Error && (error.message === 'Anonymous')) {
            // 无 token 为 free 需要去除默认内置拦截器
            isFreeView = true;
            ejectCommonInterceptor();
        }
    }
    isFirstTimeCheckSession = false;

    // 前置调用 init 判断是否有权限
    const viewInitData = await pageInit.getPatentViewInit(urlParams)
        .catch(generateExceptionRedirector(403, REQUEST_DEMO_PATH)) as ApiGetPatentViewInitResponse;

    // 无 token 即用户未登录时为 free, 有 token 即用户登陆但是无权限也为 free
    isFreeView = isFreeView || _.get(viewInitData, 'isFree', false);

    return {
        isFreeView,
        viewInitData,
    };
}
